var defineWellKnownSymbol = require('../internals/define-well-known-symbol'); // `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching


defineWellKnownSymbol('matcher');